import { combineReducers } from 'redux';

import getAvailabilityStoresReducer from './getAvailabilityStores';
import getBOPISFreeGiftAvailabilityStoresReducer from './getBOPISFreeGiftAvailabilityStores';

export const bopisReducer = combineReducers({
  getAvailabilityStoresReducer,
  getBOPISFreeGiftAvailabilityStoresReducer
});